import { Controller } from "@hotwired/stimulus"

// Keep the venue scorecard mounted; load the server-rendered network board only
// when requested. Explicit display also works with the player app's CSS reset.
export default class extends Controller {
  static targets = ["local", "network", "localLink", "networkLink", "frame"]

  connect() {
    this.select(false)
  }

  showLocal(event) {
    event.preventDefault()
    this.select(false)
  }

  showNetwork(event) {
    event.preventDefault()
    this.select(true)
    if (this.hasFrameTarget && !this.frameTarget.getAttribute("src")) {
      this.frameTarget.setAttribute("src", this.frameTarget.dataset.src)
    }
  }

  select(network) {
    for (const [panel, link, selected] of [
      [this.localTarget, this.localLinkTarget, !network],
      [this.networkTarget, this.networkLinkTarget, network]
    ]) {
      panel.hidden = !selected
      panel.style.display = selected ? "" : "none"
      link.classList.toggle("active", selected)
      link.setAttribute("aria-selected", String(selected))
    }
  }
}
